import { useNavigate } from 'react-router-dom';

interface PublisherHeaderProps {
  isLoadingBook: boolean;
  isEditMode: boolean;
  hasUnsavedChanges: boolean;
  isPublishing: boolean;
  canPublish: boolean;
  onCancel: () => void;
  onPublish: () => void;
}

export function PublisherHeader({
  isLoadingBook,
  isEditMode,
  hasUnsavedChanges,
  isPublishing,
  canPublish,
  onCancel,
  onPublish
}: PublisherHeaderProps) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (hasUnsavedChanges && !confirm('You have unsaved changes. Are you sure you want to leave?')) {
      return;
    }
    navigate('/admin/books');
  };

  return (
    <div className="bg-white border-b border-[#e7e5e4] px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <button
          onClick={handleBackClick}
          className="flex items-center gap-2 text-[#78716c] hover:text-[#292524] transition-colors"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span>Back to Books</span>
        </button>
        
        <div className="h-6 w-px bg-[#e7e5e4]"></div>
        
        <div>
          <h1 className="text-lg font-semibold text-[#292524]">
            {isLoadingBook ? 'Loading...' : isEditMode ? 'Edit Book' : 'New Book'}
          </h1>
          {hasUnsavedChanges && (
            <span className="text-xs text-[#d97706]">Unsaved changes</span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-[#78716c] hover:text-[#292524] transition-colors"
        >
          Cancel
        </button>
        
        <button
          onClick={onPublish}
          disabled={isPublishing || !canPublish}
          className="px-6 py-2 bg-[#0d9488] text-white rounded-lg hover:bg-[#0f766e] disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
        >
          {isPublishing ? (
            <>
              <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
              </svg>
              Saving...
            </>
          ) : (
            isEditMode ? 'Save Changes' : 'Publish Book'
          )}
        </button>
      </div>
    </div>
  );
}
